import React, { ReactElement, ReactNode, useState } from 'react';
import cx from 'classnames';
import { Tab } from '@headlessui/react';

export type ListItemT = {
  label: ReactNode;
  component?: ReactElement | React.FC;
  disabled?: boolean;
};

interface TabsProps {
  list: ListItemT[];
  onChange?: (inex: number) => void;
  defaultIndex?: number;
  className?: string;
  panelClassName?: string;
  variant?: 'full' | 'standard';
}

const Tabs: React.FC<TabsProps> = ({
  list,
  onChange = () => {},
  defaultIndex = 0,
  className,
  panelClassName,
  variant = 'full',
}) => {
  const [currentIndex, setCurrentIndex] = useState<number>(defaultIndex);

  return (
    <Tab.Group
      defaultIndex={defaultIndex}
      onChange={(i) => {
        onChange(i);
        setCurrentIndex(i);
      }}
      as="div"
      className={cx('tabs-wrapper', className && className)}
    >
      <Tab.List className={cx('tabs-root', variant)} as="div">
        {list.map((item, index) => (
          <Tab
            key={`tab-label-${index}`}
            disabled={item.disabled}
            className={cx('tab-item', {
              'tab-item-selected': currentIndex === index,
            })}
          >
            <div className="tab-label">{item.label}</div>
          </Tab>
        ))}
      </Tab.List>
      <Tab.Panels className="w-full overflow-hidden">
        {list.map((item, index) => (
          <Tab.Panel
            key={`tab-panel-${index}`}
            className={cx('h-full', panelClassName && panelClassName)}
          >
            {typeof item.component === 'function' && <item.component />}
            {typeof item.component === 'object' && item.component}
          </Tab.Panel>
        ))}
      </Tab.Panels>
    </Tab.Group>
  );
};

export default Tabs;
